import styled, { DefaultTheme } from 'styled-components/macro';

import ButtonIcon from 'components/ButtonIcon/ButtonIcon';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import FormTextArea from 'components/Form/FormTextArea/FormTextArea';
import { LabelStyled } from 'components/Input/Input.styled';

export const FormStyled = styled.form`
  display: flex;
  width: 100%;
  margin-top: 0.625rem;

  ${LabelStyled} {
    margin-bottom: 0;
  }
`;

export const InputMessageWrapStyled = styled.div`
  flex: 1;
  margin: 0 0.625rem;
  position: relative;
`;

export const InputImageWrapStyled = styled.div`
  margin: 0 0.625rem;
  position: relative;
  width: fit-content;
`;

export const InputTextStyled = styled(FormTextArea)`
  padding: 0.375rem 0.625rem;

  &:disabled {
    background-color: ${({ theme }) => theme.colors.primary.variant5};
  }
`;
export const CloseIconBtnStyled = styled(ButtonIcon)`
  position: absolute;
  top: 0;
  right: 0;
`;

export const StyledDragDropInput = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
`;

export const SendMessageBtnStyled = styled(ButtonIcon)`
  padding: 0.563rem;
  max-height: 38px;
`;

export const getPopupContentStyle = (theme: DefaultTheme, isMobile: boolean) => ({
  minWidth: isMobile ? '180px' : '145px',
  borderRadius: theme.radius.sm,
  padding: '20px',
});

export const PopupContainerStyled = styled(FlexContainer)`
  flex-direction: column;
  gap: 12px;
`;
